import { CREATE_BATCH } from './batch$';
import { CoordinatorService } from './coordinator.service';

export class ScriptBatchManager {
    #coords: CoordinatorService;

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
    }

    create(params?: CREATE_BATCH) {
        const b = this.#coords.batch$.create(params);
        return b.scriptClass;
    }
}
